import { Injectable } from '@angular/core';
import { Router, NavigationEnd, Event as NavigationEvent } from '@angular/router';
import { filter } from 'rxjs/operators';

declare let dataLayer: any;

@Injectable({
  providedIn: 'root'
})
export class GtmService {
  
  constructor(private router: Router) {
    this.initializeGtm();
  }

  private initializeGtm() {
    this.router.events.pipe(
      filter((event: NavigationEvent): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      dataLayer.push({
        event: 'pageview',
        pagePath: event.urlAfterRedirects
      });
    });
  }

  public pushEvent(event: any) {
    dataLayer.push(event);
  }
}
